import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HomeService } from '../shared/services/home.service';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { PerformanceTrackerService } from '../shared/services/performance-tracker.service';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-survey-builder-research',
  templateUrl: './survey-builder-research.component.html',
  styleUrls: ['./survey-builder-research.component.scss']
})
export class SurveyBuilderResearchComponent implements OnInit {
  public iframeSrcUrl:any = "";
  public studyId:any;
  public surveyId:any;
  public baseurl= "https://eagle-staging.crownit.in";
  constructor(
    private sanitizer:DomSanitizer,
    private homeService:HomeService,
    private sidePanelService:SidePanelService,
    private performanceTrackerService:PerformanceTrackerService,
    private router:Router,
    private notify:NotifierService
    
  ) { }
  ngOnInit(): void {
    setTimeout(() =>{
      if(localStorage.getItem('SurveyId')){
        this.surveyId = JSON.parse(localStorage.getItem('SurveyId'));
        let baseUrl = window.location.origin;
        if(baseUrl === 'https://research.crownit.in'){
          this.baseurl = 'https://reports.crownit.in';
        }
        if(baseUrl === 'https://research-staging.crownit.in'){
          this.baseurl = 'https://eagle-staging.crownit.in';
        }
        if(baseUrl === 'https://eagle-dev4.crownit.in'){
          this.baseurl = 'https://eagle-staging1.crownit.in';
        }
        if(baseUrl === 'https://research.eagleinsights.in'){
          this.baseurl = 'https://reports.eagleinsights.in'
        }
        this.setUrlForIframe(this.surveyId);
      }
    },10)


    // setTimeout(() =>{
    //   this.performanceTrackerService.getResponseDateQuota(this.studyId).subscribe((data) =>{
    //     if(data.result && data.result.length !== 0){
    //       if(!data['result']['api_survey_id']){
    //         this.notify.notify('error','Something Went Wrong');
    //       }else{
    //         this.surveyId = data['result']['api_survey_id'];
    //         let baseUrl = window.location.origin;
    //         if(baseUrl === 'https://research.crownit.in'){
    //           this.baseurl = 'https://reports.crownit.in';
    //         }
    //         if(baseUrl === 'https://research-staging.crownit.in'){
    //           this.baseurl = 'https://eagle-staging.crownit.in';
    //         }
    //         if(baseUrl === 'https://research.eagleinsights.in'){
    //           this.baseurl = 'https://reports.eagleinsights.in'
    //         }
    //         this.setUrlForIframe(this.surveyId);
    //       }
    //     }
    //   })
    // },10)
    
  }


  




  

  setUrlForIframe(id){
    this.iframeSrcUrl = `${this.baseurl}/managesurvey/${id}?research=true&hide_sd=true`;
    this.iframeSrcUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeSrcUrl);
  }


}
